import { render, staticRenderFns } from "./SmallSubCollapsePanel.vue?vue&type=template&id=67649251&scoped=true"
import script from "./SmallSubCollapsePanel.vue?vue&type=script&lang=js"
export * from "./SmallSubCollapsePanel.vue?vue&type=script&lang=js"
import style0 from "./SmallSubCollapsePanel.vue?vue&type=style&index=0&id=67649251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67649251",
  null
  
)

export default component.exports